"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSubstance = void 0;
class StandardSubstance {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.StandardSubstance = StandardSubstance;
(function (StandardSubstance) {
    StandardSubstance.TypeEnum = {
        CAS: 'CAS',
        DMD: 'DM_D',
        EDQM: 'EDQM',
        SNOMEDCT: 'SNOMED_CT',
    };
})(StandardSubstance = exports.StandardSubstance || (exports.StandardSubstance = {}));
//# sourceMappingURL=StandardSubstance.js.map